import React, { useEffect, useState } from 'react';
import { TableBody, Table, TableCell, TableRow } from '@material-ui/core';
import { useSelector } from 'react-redux';

const SecondTopTable = () => {
    const {isMobile, secondTopTableData}=  useSelector(state=> state.appReducer);
    const [rows, setRows] = useState([])
    const setTypes = () => {
        const objectValues = Object.values(secondTopTableData)
        let array = []
        array = objectValues
        const ColorandText = array.map((element) => {
            switch (true) {
                case element === -1 :
                    return { number: "-", colorCode: "#a5a6a7", text: "" }
                case element >= 0 && element <= 9:
                    return { number: element, colorCode: "#05b050", text: "Very Bullish" }

                case element >= 10 && element <= 39:

                    return { number: element, colorCode: "#0a833b", text: "Bullish" }
                case element >= 40 && element <= 60:
                    return { number: element, colorCode: "#a5a6a7", text: "Neutral" }
                case element >= 61 && element <= 90:
                    return { number: element, colorCode: "#c10200", text: "Bearish" }
                case element >= 91 && element <= 100:
                    return  isMobile ?  { number: element, colorCode: "#fe0602", text: "Very Bear" } : { number: element, colorCode: "#fe0602",  text: "Very Bearish" }
                default:
                    return 'Number not found'

            }
        })
        setRows(ColorandText)
    }

    useEffect(() => {
        setTypes()
    }, [secondTopTableData])

    return (
        <div>
            <div style={{
                backgroundColor: '#404040',
                fontSize: '10px', marginLeft: '0px', color: 'white', paddingTop: '4px',paddingBottom:"3px",
                textAlign:"center" 
            }}>
                Options Sentiment
                </div>
            <Table style={{ marginTop: '0px' }}>
                <TableBody>

                    <TableRow>
                        <TableCell
                            style={{ padding: '0px', border: '1.2px solid', backgroundColor: '#fffeff', width: isMobile? '40px' : window.innerWidth > 1400 ? '100px' : '40px' , fontSize: '12px', textAlign: 'center' }}>
                            1mo
                        </TableCell>
                        <TableCell
                            style={{ padding: '0px', border: '1.2px solid', backgroundColor: rows.length ? rows[0].colorCode : "#fffeff", fontSize: '12px', textAlign: 'center', width: '120px' }}>
                               <div style={{color:'white'}}> {rows.length ? `${rows[0].text}  ${rows[0].number}` : 0}</div>

                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell
                            style={{ padding: '0px', border: '1.2px solid', backgroundColor: '#fffeff', width: isMobile? '40px' : window.innerWidth > 1400 ? '100px' : '40px' , fontSize: '12px', textAlign: 'center' }}
                        >
                            3mo
                        </TableCell>

                        <TableCell
                            style={{ padding: '0px', border: '1.2px solid', backgroundColor: rows.length ? rows[1].colorCode : "#fffeff", fontSize: '12px', textAlign: 'center', width: '120px' }}>
                            <div style={{color:'white'}}>{rows.length ? `${rows[1].text}  ${rows[1].number}` : 0}</div>

                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell
                            style={{ padding: '0px', border: '1.2px solid', backgroundColor: '#fffeff', width: isMobile? '40px' : window.innerWidth > 1400 ? '100px' : '40px' , fontSize: '12px', textAlign: 'center' }}>
                            6mo
                        </TableCell>
                        <TableCell
                            style={{ padding: '0px', border: '1.2px solid', backgroundColor: rows.length ? rows[2].colorCode : "#fffeff", fontSize: '12px', textAlign: 'center', width: '120px' }}>
                            <div style={{color:'white'}}>{rows.length ? `${rows[2].text}  ${rows[2].number}` : 0}</div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell
                            style={{ padding: '0px', border: '1.2px solid', backgroundColor: '#fffeff', width: isMobile? '40px' : window.innerWidth > 1400 ? '100px' : '40px' , fontSize: '12px', textAlign: 'center' }}>
                            { isMobile? '1yr' :  '1 Year'}
                        </TableCell>
                        <TableCell
                            style={{ padding: '0px', border: '1.2px solid', backgroundColor: rows.length ? rows[3].colorCode : "#fffeff", fontSize: '12px', textAlign: 'center', width: '120px' }}>
                           <div style={{color:'white'}}> {rows.length ? `${rows[3].text}  ${rows[3].number}` : 0}</div>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );

}

export default SecondTopTable


// WEBPACK FOOTER //
// ./src/Pages/Stock/topSecondTable.js